import styled from 'styled-components';

export const Spacing = styled.section`
    --spacing: ${props => props.$spacingLg ? props.$spacingLg : '120px'};
    @media screen and (max-width: 1024px) { --spacing: ${props => props.$spacingMd ? props.$spacingMd : '80px'}; }
    @media screen and (max-width: 475px) { --spacing: ${props => props.$spacingSm ? props.$spacingSm : '60px'}; }

    margin-bottom: var(--spacing);
`;